"use client"
import styled from "@emotion/styled"
import { Select } from "@mui/material"

export const StyledSelect = styled(Select)`
  & .MuiSelect-select {
    text-align: left;
  }
  & > .MuiFilledInput-input {
    font-size: 16px;
  }
  & > .MuiPopover-root {
  }
  border-radius: 4px;
  .MuiMenu-paper {
    padding: 0;
    max-height: 200px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    ul {
      display: flex;
      flex-direction: column;
      padding: 0;
      border-radius: 4px;
    }
  }
`
